$(document).ready(function () {
    // слайдер Swiper
    const dolyameSlider = new Swiper('#dolyameSliderWrap .dolyameSlider', {
        // Optional parameters
        loop: true,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },

        // Pagination
        pagination: {
            el: '#dolyameSliderWrap .swiper-pagination',
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: '#dolyameSliderWrap .swiper-button-next',
            prevEl: '#dolyameSliderWrap .swiper-button-prev',
        }
    });
});
